import * as React from 'react'

import Grid from '@material-ui/core/Grid'

import hooks                    from '../../../testing-hooks'
import { FormikFormChunkProps } from '../../../types'
import {
  EnhancedTextField,
  PasswordField,
}                               from '../../atoms'
import propsProxy               from '../../hocs/propsProxy'
import { mapFormikToMuiProps }  from '../form-utils'
import { CredentialsFields }    from '../types'

const CredentialsChunk: React.SFC<FormikFormChunkProps<CredentialsFields>> = props => {
  const mapper = mapFormikToMuiProps(props)

  return (
    <Grid container spacing={8}>
      <Grid item xs={12}>
        <EnhancedTextField
          {...mapper('email')}
          autoFocus
          fullWidth
          FormHelperTextProps={{
            component: propsProxy({ 'data-test-id': hooks.errors.password })('p'),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PasswordField
          {...mapper('password')}
          fullWidth
          autoComplete={'password'}
          FormHelperTextProps={{
            component: propsProxy({ 'data-test-id': hooks.errors.password })('p'),
          }}
        />
      </Grid>
    </Grid>
  )
}

export default CredentialsChunk



// WEBPACK FOOTER //
// ./src/components/forms/chunks/CredentialsChunk.tsx